import request from '@/utils/request';

// post /api/v1/admin/members/member_configuration/change_payout_limit_logs
export function changePayoutLimitLogs(data) {
  return request({
    url: '/api/v1/admin/members/member_configuration/change_payout_limit_logs',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/members/member_configuration/payout_limit
export function payoutLimitList(data) {
  return request({
    url: '/api/v1/admin/members/member_configuration/payout_limit_list',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/members/member_configuration/payout_limit_add
export function payoutLimitAdd(data) {
  return request({
    url: '/api/v1/admin/members/member_configuration/payout_limit_add',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/members/member_configuration/payout_limit_delete
export function payoutLimitDelete(data) {
  return request({
    url: '/api/v1/admin/members/member_configuration/payout_limit_delete',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/members/member_configuration/payout_limit_update
export function payoutLimitUpdate(data) {
  return request({
    url: '/api/v1/admin/members/member_configuration/payout_limit_update',
    method: 'post',
    mock: false,
    data
  })
}
